import React from "react";

const ComingSoon = ({ title }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
    <h1 className="text-3xl font-bold mb-4 text-white">{title}</h1>
    <p className="text-lg text-gray-400">
      This page will be replaced with authentication soon.
    </p>
  </div>
);

export default ComingSoon;
